import { cn } from '@/app/_lib/utils';

type SidebarUserInfoProps = {
  email?: string | null;
  alias?: string | null;
  spend?: number | null;
  className?: string;
};

export default function SidebarUserInfo({
  email,
  alias,
  spend,
  className,
}: SidebarUserInfoProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-start text-left min-w-0 flex-1 gap-1',
        className,
      )}
    >
      <span className="text-xs font-medium truncate w-full">
        {email || 'Loading...'}
      </span>
      <div className="flex items-center justify-between w-full">
        <span className="text-xs text-muted-foreground truncate flex-1 mr-2">
          {alias || 'User'}
        </span>
        <span className="text-xs text-muted-foreground font-mono shrink-0">
          ${((spend ?? 0) as number).toFixed(2)} spent
        </span>
      </div>
    </div>
  );
}
